export const SET_CARD_COLOR = 'SET_CARD_COLOR';

export default { SET_CARD_COLOR };
